<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>
<div class="container-fluid p-5">
    <h3>Registro de Compras</h3>
    <div class="btn btn-primary my-2" [routerLink]="['/compra/create']"><i class="fas fa-plus-circle me-2"></i>Registrar
        Nueva Compra</div>
    <br>
    <kuv-lazy-table [url]="config.apiUrl + 'compra/index'" [urlExcel]="config.apiUrl + 'compra/excel'"
        [headersBlob]="sesion.headersBlob" [filtros]="filtros" [columnas]="columnas" [acciones]="acciones"
        [headers]="sesion.headers" [reloadEmitter]="reloadEmitter" [useIndex]="true" [isRounded]="true"
        [hasShadow]="true"></kuv-lazy-table>
</div>